export default "__VITE_ASSET__1bb7e6d8__"